import { translate } from "@/plugins/i18n";
import type BaseEnumType from "../../baseEnumType";
import Key from "@/app/types/common/key";
import { Maybe } from "@/components/utils/typeHelpers";


export class EnumDistributionType implements BaseEnumType {
  private static allValues: EnumDistributionType[] = []; // make sure this is top-most
  
  public static none = new EnumDistributionType(0, "None", "enum_distribution_type_none");
  public static delivery = new EnumDistributionType(1, "Delivery", "enum_distribution_type_delivery");
  public static courier = new EnumDistributionType(2, "Courier", "enum_distribution_type_courier");
  public static collection = new EnumDistributionType(3, "Collection", "enum_distribution_type_collection");
  
  public key: number;
  public value: string;
  public translationKey: string;

  private constructor(key: number, value: string, translationKey: string) {
    this.key = key;
    this.value = value;
    this.translationKey = translationKey;
    EnumDistributionType.allValues.push(this);
  }

  public get translation() { return translate(Key.fromString(this.translationKey)); }

  public isNone() { return this === EnumDistributionType.none; }
  public isDelivery() { return this === EnumDistributionType.delivery; }
  public isCourier() { return this === EnumDistributionType.courier; }
  public isCollection() { return this === EnumDistributionType.collection; }

  public static getValues(): readonly EnumDistributionType[] {
    return EnumDistributionType.allValues;
  }

  public static getValuesExcept0(): readonly EnumDistributionType[] {
    return EnumDistributionType.allValues.filter((x) => x.key !== 0);
  }

  public static getByKey(key: number): EnumDistributionType {
    const found = EnumDistributionType.allValues.find(e => e.key === key);
    if (found === undefined) {
      throw new Error(`EnumDistributionType - Key not found: ${ key }`);
    }

    return found;
  }

  public static getByValue(name: string, def?: EnumDistributionType): EnumDistributionType {
    const found = name ? EnumDistributionType.allValues.find(e => e.value.toLowerCase() === name.toLowerCase()) : null;
    if (!found) {
      if (def) {
        return def;
      }
      throw new Error(`EnumDistributionType - Value not found: ${ name }`);
    }

    return found;
  }

  public equals(other: Maybe<EnumDistributionType>): boolean {
    return this.key === other?.key;
  }
}